import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  logo: {
    fill: "#f26522",
  },
}));

export interface LogoProps {
  height?: number;
  width?: number;
  mini?: boolean;
}
export const Logo = ({ height, width, mini }: LogoProps): JSX.Element => {
  const classes = useStyles();
  if (mini) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-2 0 89.8 89.7"
        preserveAspectRatio="xMinYMid"
        className="c-logo"
        width={width}
        height={height}
      >
        <path
          d="M40.6 69.5L17.4 56.2V33.5l16.1-9.3v3.7l-12.9 7.5v18.9l20 11.5v-8.2l-12.9-7.4V39.4L40.6 32V11.9L10.3 29.4v30.8l23.2 13.4v3.8L7.1 62.1V27.5L40.6 8.2V0L0 23.4v42.8l40.6 23.5zM43.8 20.1L67 33.5v22.7l-16.1 9.2v-3.7l12.9-7.4V35.4l-20-11.6V32l12.9 7.4v10.8l-12.9 7.4v20.1l30.3-17.5V29.4L50.9 16v-3.7l26.4 15.2v34.6L43.8 81.5v8.2l40.6-23.5V23.4L43.8 0z"
          className={classes.logo}
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 333.5 89.7"
      preserveAspectRatio="xMinYMid"
      className="c-logo"
      width={width}
      height={height}
    >
      <path
        d="M40.6 69.5L17.4 56.2V33.5l16.1-9.3v3.7l-12.9 7.5v18.9l20 11.5v-8.2l-12.9-7.4V39.4L40.6 32V11.9L10.3 29.4v30.8l23.2 13.4v3.8L7.1 62.1V27.5L40.6 8.2V0L0 23.4v42.8l40.6 23.5zM43.8 20.1L67 33.5v22.7l-16.1 9.2v-3.7l12.9-7.4V35.4l-20-11.6V32l12.9 7.4v10.8l-12.9 7.4v20.1l30.3-17.5V29.4L50.9 16v-3.7l26.4 15.2v34.6L43.8 81.5v8.2l40.6-23.5V23.4L43.8 0z"
        className={classes.logo}
      />
      <g>
        <path
          d="M130 50.2c-2.4 2.2-4.3 3.4-7.5 3.4-4.6 0-8-3.8-8-8.9 0-5 3.5-8.7 8-8.7 2.6 0 4.8 1 7.3 3.3l.8.7 5.7-6.5-.7-.7c-3.6-3.5-7.6-5.1-13-5.1-9.9 0-17.3 7.4-17.3 17.3 0 9.6 7.5 17.1 17 17.1 5.6 0 9.7-1.8 13.5-5.9l.7-.7-5.7-5.8-.8.5zM156.2 27.7c-9.9 0-17.7 7.5-17.7 17.3 0 9.7 7.6 17.1 17.6 17.1 9.9 0 17.7-7.5 17.7-17.3s-7.6-17.1-17.6-17.1zm-.1 8.3c4.8 0 8.4 3.8 8.4 8.9 0 5-3.6 8.7-8.4 8.7-4.8 0-8.4-3.8-8.4-8.9.1-4.9 3.7-8.7 8.4-8.7zM205.6 39.5c0-3.2-1-5.9-3-7.9-2.3-2.3-5.7-3.5-9.8-3.5h-15.3v33.3h8.9v-10h3.8l6.7 10h10.5l-8-11.7c4-1.9 6.2-5.4 6.2-10.2zm-9 .5c0 2.1-1.6 3.4-4.3 3.4h-5.9v-6.9h5.8c2.9-.1 4.4 1.1 4.4 3.5zM219.1 48.8h14.7v-8.2h-14.7v-4.3h16.7v-8.1h-25.6v33.3h25.9v-8.2h-17zM239.9 36.6h9.5v24.9h8.9V36.6h9.5v-8.4h-27.9zM280.7 48.8h14.7v-8.2h-14.7v-4.3h16.7v-8.1h-25.5v33.3h25.8v-8.2h-17zM321.9 44.5L333 28.2h-10.2l-6.1 9.3-6-9.3h-10.5l11.1 16.4-11.6 16.9H310l6.5-9.9 6.5 9.9h10.5z"
          className="c-logo__logotype"
          fill="white"
        />
      </g>
    </svg>
  );
};
